ApiError = require 'network/api-error'
CreditCardFormError = require './internal/credit-card-form-error'
PaidAccount = require 'network/paid-account'
PopOver = require 'views/lib/pop-over'
React = require 'react'
ReactDOM = require 'react-dom'
ReactRootComponent = require 'views/internal/react-root-component'
View = require 'view'
CreditCardUpdateComponent = require 'views/billing/form-sections/credit-card-update-component'
t = require('views/internal/recup-with-helpers')('credit_card')

module.exports = class ChangeCreditCardView extends View
  viewTitleKey: 'change credit card'

  renderOnce: ->
    @reactRoot ?= document.createElement('div')
    @$el.prepend @reactRoot
    @renderReactSection()

    @

  getReactRoot: ->
    React.createElement ReactRootComponent, {},
      @getFormComponent()


  renderReactSection: ->
    ReactDOM.render @getReactRoot(), @reactRoot

    @

  getFormComponent: ->
    t.render => t.div =>
      t.createElement CreditCardUpdateComponent,
        onSubmit: (data) =>
          PaidAccount.changeCreditCard(@model, data)
          .catch ApiError.BadRequest, (err) ->
            for field in ['country', 'zipCode', 'taxId']
              if err.message.trim() == "invalid value for #{ field }"
                throw CreditCardFormError.InvalidField('', { field })

            throw CreditCardFormError.PostError(err.message)
          .then (res) =>
            @model.set(res)
            PopOver.hide()





// WEBPACK FOOTER //
// ./app/scripts/views/billing/change-credit-card-view.coffee